<template>
  <div :class="classes">
    <wt-paged-table :isAddPageToRouter="isAddPageToRouter" :on-request-data="getTableData" :total-size="totalNumber" :page-size="pageSize" :refresh="true" ref="table" @size-change="handleSizeChange" :layout="layout" :pageSizes="pageSizes">
      <!-- <wt-table :list="tableData" :labels="tableLabels" >
        <template>
          <el-table-column label="操作" fixed="right" min-width="20">
            <template slot-scope="scope">
              <slot :row="scope.row"></slot>
            </template>
          </el-table-column>
        </template>
      </wt-table> -->
      <base-table
        ref="multipleTable"
        :columns="tableLabels"
        :selectType="selectType"
        :table-data="tableData"
        :selectedKeys="selectedKeys"
        @selection-change="handleSelectionChange"
      >
      <template slot="reportNum" slot-scope="scope">
           <slot :row="scope.row" name="reportNum"></slot>
      </template>
      <template slot="billStatusEnum" slot-scope="scope">
        <slot :row="scope.row" name="billStatusEnum"></slot>
      </template>

      <template slot="operate" slot-scope="scope">
        <slot :row="scope.row"></slot>
      </template>
      
        <!-- <slot :row="props.row"></slot> -->
      </base-table>
    </wt-paged-table>
  </div>
</template>

<script>
// 组件class前缀
const prefixCls = "pt-trust-deed-table";

export default {
  name: "pt-trust-deed-table",
  computed: {
    classes() {
      return `${prefixCls}`;
    }
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tableLabels: {
      type: Array,
      default: () => []
    },
    totalNumber: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 0
    },
    requestData: {
      type: Function
    },
    selectType:{
      type:String,
      default:'checkbox'
    },
    layout: {
      type: String,
      default: 'total, prev, pager, next,jumper'
    },
    pageSizes: {
      type: Array,
      default: function () {
        return []
      }
    },
    isAddPageToRouter: {
      type: Boolean,
      default: true
    },
    // 传进的id // 用于回显
    selectedKeys: {
      type: String,
      default: ''
    },
  },
  methods: {
    handleSizeChange (val) {
      this.$emit('size-change', val)
    },
    getTableData (page, next) {
      this.requestData && this.requestData(page, next)
    },
    resetPage(){
      this.$refs.table.resetPage()
    },
    reload () {
      this.$refs.table.load()
      this.clearSelection()
    },
    clearSelection () {
      this.$refs.multipleTable.clearSelection()
    },
    showReTry () {
      this.$refs.table.showReTry()
    },
    handleSelectionChange(val){
      this.$emit('selection-change',val)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
